import utils from '~/utils/utils';

export default {
    updateLoadingState(state, payload) {
        state[payload.loading] = payload.state;
    },

    updateFormEditableParam(state, payload) {
        state.formEditableParam = payload;
    },

    updateFormMediaCategoryParam(state, payload) {
        state.formMediaCategoryParam = payload;
    },

    getFormData(state, payload) {
        state.media = payload.media;
        state.share_error = payload.share_error;
        state.error_message = payload.error_message;
        state.show_form = payload.show_form;
        state.show_website_question = payload.show_website_question;
        state.formData.post_image_url = payload.post_image_url;
        state.social_networks = payload.social_networks;
        state.shareable_networks = payload.shareable_networks;
        state.websites = payload.websites;
        state.twitter_url_length = payload.twitter_url_length;
        state.is_video_link = payload.is_video_link;

        Object.assign(state.formData, {
            max_date: payload.max_date,
            editable: payload.editable,
            category: payload.category,
            post_message: payload.post_message ? payload.post_message : '',
            media_id: payload.media.media_id,
            video_url: payload.video_url,
            website: payload.website
        });
    },

    updateSocialNetworkConnection(state, payload) {
        const network = state.social_networks.find((item) => item.system_name === payload.network);

        if (payload.network == 'twitter' || payload.network == 'linkedin') {
            network.user_connected = true;
        } else if (payload.network == 'facebook' && payload.is_active) {
            network.user_connected = true;
        }
    },

    resetFormData(state, payload) {
        state.formData.id = null;
        state.formData.post_now = false;
        state.formData.media_id = null;
        state.formData.saved_media_id = null;
        state.formData.max_date = null;
        state.formData.editable = null;
        state.formData.social_networks = [];
        state.formData.post_date = null;
        state.formData.post_time = '12:00:00',
        state.formData.remove_date = null;
        state.formData.post_message = '';
        state.formData.website = '';
        state.formData.post_image_url = null;
        state.formData.video_url = null;
    },

    commitScheduledPosts(state, payload) {
        state.posts = payload.posts;
    },

    concatPosts(state, payload) {
        state.posts = state.posts.concat(payload.posts);
    },

    resetPosts(state, payload) {
        state.posts = [];
    },

    getPost(state, payload) {
        const network = state.shareable_networks.find((item) => item.id === payload.post.network_id);

        utils.assignExisting(state.formData, payload.post);
        state.formData.remove_date = payload.post.expiration_date;
        state.formData.website = payload.post.user_website;
        state.formData.post_image_url = payload.post.post_image_url;

        state.formData.social_networks.push({
            id: network.id,
            system_name: network.system_name,
        });
    },

    addPosts(state, payload) {
        state.posts = payload.posts.concat(state.posts);
    },

    updatePost(state, payload) {
        const index = state.posts.findIndex((item) => item.id == payload.id);

        state.posts.splice(index, 1, payload);
    },

    removePost(state, payload) {
        const index = state.posts.findIndex((item) => item.id == payload);

        state.posts.splice(index, 1);
    },

    updateParams(state, payload) {
        Object.assign(state.params, payload);
    },

    updateFormData(state, payload) {
        Object.assign(state.formData, payload);
    },

    addSocialNetwork(state, payload) {
        state.formData.social_networks.push(payload);
    },

    removeSocialNetwork(state, payload) {
        const networks = state.formData.social_networks;
        const index = networks.findIndex((item) => item[payload.account_type] === payload[payload.account_type]);

        networks.splice(index, 1);
    },
};
